import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import { useActivityActions, useActivity } from '../../hooks';
import ActivityForm from '../../components/ActivityForm';
import { ActivityInput } from '../../types';

interface EditActivityPageRouteParams {
  courseId: string;
  activityId: string;
}

const EditActivityPage = () => {
  const { courseId, activityId } = useParams<EditActivityPageRouteParams>();
  const history = useHistory();
  const { activity, loading } = useActivity({ courseId, activityId });
  const { onUpdateActivity, updateActivityError, updateActivityLoading } = useActivityActions({ courseId });

  const handleGoBack = useCallback(() => {
    history.push(`/${courseId}/activities`);
  }, [history, courseId]);

  const handleUpdateActivity = useCallback(
    (input: ActivityInput) => {
      onUpdateActivity(activityId, input);
    },
    [onUpdateActivity, activityId]
  );

  return (
    <>
      <BackButton onGoBack={handleGoBack} title="Editar Tarea" subtitle="Tareas" />
      <Box mt={2}>
        {!loading && (
          <ActivityForm
            activity={activity}
            loading={loading}
            submitting={updateActivityLoading}
            submitError={updateActivityError}
            onSubmit={handleUpdateActivity}
          />
        )}
      </Box>
    </>
  );
};

export default EditActivityPage;
